The identifier for the `WebhookSubscription`.
